import type { Playlist, PlaylistItem } from '../../types/playlist';

type ScreenPredicate<T> = (data?: T) => boolean;

type ScreenDefinition<T, C> = {
  predicate: ScreenPredicate<T>;
  component: C;
};

export class ScreenMap<T extends Playlist | PlaylistItem, C> {
  private defaultScreen?: C = undefined;
  private definitions: ScreenDefinition<T, C>[] = [];

  register(component: C, predicate: ScreenPredicate<T>) {
    this.definitions.push({ component, predicate });
  }

  // add new condition based on contenttype type
  registerByContentType(component: C, contentTypes: string | readonly string[]) {
    this.register(component, (data) => {
      const contentType = data?.contentType?.toLowerCase();

      if (Array.isArray(contentTypes)) {
        return contentTypes.includes(contentType);
      }

      return contentType === contentTypes;
    });
  }

  registerDefault(component: C) {
    this.defaultScreen = component;
  }

  getScreen(data?: T): C {
    const screen = this.definitions.find(({ predicate }) => predicate(data))?.component;

    if (screen) {
      return screen;
    }

    if (!this.defaultScreen) {
      throw new Error('Default screen not defined');
    }

    return this.defaultScreen;
  }
}
